module.exports = __webpack_public_path__ + "static/media/3_elephant_tiger.909eebd2.png";